import { Box } from '@mui/material';
import { DataCellProps } from '../types';

export const DataDeletionRealmCell = ({ team }: DataCellProps) => {
  return <Box>{team.realmId}</Box>;
};
